(function(){
  function initializeNavigation(){
    var nav=document.querySelector('.rs28-chapters__links');
    if(!nav||nav.dataset.rs28Ready==='true'||!('IntersectionObserver' in window))return;
    nav.dataset.rs28Ready='true';
    var links=Array.prototype.slice.call(nav.querySelectorAll('a[href^="#"]'));
    var sections=links.map(function(link){return document.getElementById(link.getAttribute('href').slice(1))}).filter(Boolean);
    if(!sections.length)return;
    var current='';
    var observer=new IntersectionObserver(function(entries){
      entries.forEach(function(entry){
        if(entry.isIntersecting) current=entry.target.id;
      });
      if(!current)return;
      links.forEach(function(link){
        if(link.getAttribute('href')==='#'+current)link.setAttribute('aria-current','location');
        else link.removeAttribute('aria-current');
      });
    },{rootMargin:'-24% 0px -65% 0px',threshold:0});
    sections.forEach(function(section){observer.observe(section)});
  }
  function init(){initializeNavigation()}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);
  else init();
  document.addEventListener('shopify:section:load',init);
})();